// @flow
import 'mapbox-gl/dist/mapbox-gl.css';

import { motion } from 'framer-motion';
import { InView } from 'react-intersection-observer';
import { Button, Container, Typography } from '@material-ui/core';
import { graphql, useStaticQuery } from 'gatsby';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import mapboxgl from 'mapbox-gl';

import Markers from './markers';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: 'calc(80vh)',
    position: 'relative',
  },
  overlay: {
    position: 'absolute',
    top: 'calc(30vh)',
    zIndex: 2,
  },
  map: {
    height: 'calc(80vh)',
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(-2),
  },
  textWhite: {
    color: 'white',
    fontWeight: 600,
    textShadow: `${theme.palette.primary.main} 10px 10px 10px`,
  },
  textYellow: {
    marginTop: -20,
    color: theme.palette.secondary.main,
    fontWeight: 600,
    textShadow: `${theme.palette.primary.main} 10px 10px 10px`,
  },
}));

const SUCURSALES = graphql`
  query SucursalesQuery {
    allContentfulSucursal {
      nodes {
        direccion
        id
        nombre
        telefonos
        coordenadas {
          lat
          lon
        }
        url
      }
    }
  }
`;

const Map = () => {
  const classes = useStyles();
  const mapContainerRef = React.useRef(null);
  const [map, setMap] = React.useState(null);
  const {
    allContentfulSucursal: { nodes: sucursales },
  } = useStaticQuery(SUCURSALES);
  const variants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  const places = sucursales.map(({ nombre, coordenadas, id }) => ({
    id,
    name: nombre,
    longitude: coordenadas.lon,
    latitude: coordenadas.lat,
  }));

  React.useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      accessToken: process.env.GATSBY_MAPBOX_TOKEN,
      style: 'mapbox://styles/mapbox/dark-v10',
      center: [
        sucursales[0]?.coordenadas?.lon,
        sucursales[0]?.coordenadas?.lat,
      ],
      zoom: 14,
    });

    setMap(map);

    return () => map.remove();
  }, []);

  return (
    <InView threshold={0.1}>
      {({ inView, ref }) => (
        <motion.div
          className={classes.root}
          animate={inView ? 'visible' : 'hidden'}
          ref={ref}
          variants={variants}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <div className={classes.overlay}>
            <InView threshold={0.5}>
              {({ inView, ref }) => (
                <Container
                  maxWidth="md"
                  component={motion.div}
                  animate={inView ? 'visible' : 'hidden'}
                  ref={ref}
                  variants={variants}
                  transition={{ duration: 0.7, ease: 'easeOut' }}
                >
                  <Typography className={classes.textWhite} variant="h1">
                    Esperamos
                  </Typography>
                  <Typography className={classes.textYellow} variant="h1">
                    verte...
                  </Typography>
                  <Button
                    size="large"
                    href={sucursales[0]?.url}
                    className={classes.button}
                    variant="contained"
                    color="primary"
                  >
                    Sigue la ruta
                  </Button>
                </Container>
              )}
            </InView>
          </div>
          <div ref={mapContainerRef} className={classes.map}>
            {map && <Markers map={map} places={places} />}
          </div>
        </motion.div>
      )}
    </InView>
  );
};

export default Map;
